const reverse = (array) => [...array].reverse();
export const reverseGeoJSONFeatureGeometry = (geoJSONFeature) => ({
    ...geoJSONFeature,
    geometry: reverseGeoJSONGeometry(geoJSONFeature.geometry),
});
export const reverseGeoJSONGeometry = (geoJSONFeature) => {
    switch (geoJSONFeature.type) {
        case 'LineString': {
            return {
                ...geoJSONFeature,
                coordinates: reverse(geoJSONFeature.coordinates),
            };
        }
        case 'MultiLineString': {
            return {
                ...geoJSONFeature,
                coordinates: geoJSONFeature.coordinates.map(reverse),
            };
        }
        default: {
            return geoJSONFeature;
        }
    }
};
//# sourceMappingURL=reverseGeoJSONGeometry.js.map